import {
  Button,
  Col,
  Dropdown,
  Form,
  Menu,
  Row,
  Select,
  Typography,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { routes } from "../../routes";
import {
  importFile,
  downloadImportFile,
} from "../../services/importFileService";
import useListFileImport from "../../lib/hooks/useListFileImport";
import useListTemplateImport from "../../lib/hooks/useListTemplateImport";
import WithSidebar from "../../templates/withSidebar";
import {
  ArrowRightOutlined,
  CloudUploadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import React from "react";
import SuccessModal from "../../components/modal/successModal";
import FailModal from "../../components/modal/failModal";
import { useDropzone } from "react-dropzone";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  padding: "20px",
  marginBottom: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const baseStyleHover = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  padding: "20px",
  marginBottom: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#2E90FA",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const Option = Select.Option;
const { Title } = Typography;

const ImportFile = () => {
  const [form] = Form.useForm();
  const [listFileImport] = useListFileImport();
  const [listTemplateImport] = useListTemplateImport();
  const [type, setType] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [failTitle, setFailTitle] = useState("");
  const [failSubtitle, setFailSubtitle] = useState("");

  const [dataShow, setDataShow] = useState([]);

  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const onDrop = async (acceptedFiles) => {
    if (acceptedFiles[0] === undefined) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("นำเข้าไฟล์เกิน 1 ไฟล์");
    } else if (acceptedFiles[0].size > 10485760) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("ขนาดไฟล์เกิน 10 MB");
    } else if (
      acceptedFiles[0].name.includes(".xlsx") === false &&
      acceptedFiles[0].name.includes(".xls") === false
    ) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("รองรับนามสกุล .xlsx เท่านั้น");
    } else if (type === "") {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
    } else if (
      type === "customerInEstate" &&
      acceptedFiles[0].name !== "Customer_in_the_estate.xlsx"
    ) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
    } else if (
      type === "formerCustomer" &&
      acceptedFiles[0].name !== "Former_Customer.xlsx"
    ) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
    } else if (
      type === "futureCustomer" &&
      acceptedFiles[0].name !== "Future_Customer.xlsx"
    ) {
      setFailModal(true);
      setFailTitle("นำเข้าไม่สำเร็จ");
      setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
    } else {
      const formData = new FormData();
      formData.append("file", acceptedFiles[0]);
      formData.append("template", type);

      const res = await importFile(formData);
      //console.log("");
      //alert("res.data.code=>"+res.data.code);
      if (res.data.code === "0000") {
        setDataShow(res);
        setSuccessModal(true);
      } else {
        setFailModal(true);
        setFailTitle("นำเข้าไม่สำเร็จ");
        setFailSubtitle("กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล");
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  const downloadFile = useCallback(async (fileName) => {
    const res = await downloadImportFile(fileName);
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(
      new Blob([res.data], { type: "application/vnd.ms-excel" })
    );
    link.download = fileName;
    link.click();
  }, []);

  const menu = (
    <Menu style={{ marginTop: "-11px" }}>
      {listTemplateImport
        // .filter((item) => item.dataDetailTh !== "")
        .map((temp, idx) => (
          <Menu.Item key={idx} onClick={() => downloadFile(temp.dataDetailEn)}>
            {temp.dataDetailTh || temp.dataDetailEn}
          </Menu.Item>
        ))}
    </Menu>
  );

  useEffect(() => {}, []);

  return (
    <WithSidebar>
      <Row gutter={[16]}>
        <Col span={24}>
          <div className="flex justify-between items-center">
            <Title level={4} style={{ marginTop: 25 }}>
              อัปโหลด Raw Data
            </Title>
            <div>
              <Dropdown overlay={menu} placement="bottomRight" arrow>
                <Button>
                  <UploadOutlined /> ดาวน์โหลดฟอร์ม
                </Button>
              </Dropdown>
            </div>
          </div>
        </Col>
      </Row>

      <div style={{ margin: "40px 200px" }}>
        <Form
          form={form}
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={[24, 16]} style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Form.Item
                label="ประเภทแบบฟอร์มที่นำเข้าข้อมูล"
                name={"type"}
                rules={[
                  {
                    required: type === "" ? true : false,
                    message: "กรุณาระบุประเภทแบบฟอร์มที่นำเข้าข้อมูล",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก"
                  onChange={(value) => setType(value)}
                >
                  {listFileImport.map((item) => (
                    <Option key={item.dataId} value={item.dataDetailEn}>
                      {item.dataDetailTh}
                    </Option>
                  ))}
                </Select>
                {/* <Select
                  allowClear
                  defaultValue="กรุณาเลือก"
                  style={{
                    width: "100%",
                  }}
                  onChange={(value) => setType(value)}
                >
                  <Option value="customerInEstate">ลูกค้าในนิคม</Option>
                  <Option value="formerCustomer">ลูกค้าอดีต</Option>
                  <Option value="futureCustomer">ลูกค้าอนาคต</Option>
                  <Option value="touchPoint">Touch Point</Option>
                </Select> */}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[24, 16]} style={{ margin: "0px 8px" }}>
            <section style={{ display: "contents" }}>
              <div
                {...getRootProps()}
                style={isHover ? baseStyleHover : baseStyle}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <input {...getInputProps()} />

                <p className="ant-upload-drag-icon">
                  <CloudUploadOutlined
                    style={{ color: "#1677ff", fontSize: 52 }}
                  />
                </p>
                <p className="ant-upload-text" style={{ fontWeight: 600 }}>
                  Drag & drop files or{" "}
                  <span style={{ color: "#2E90FA" }}>Browse</span>
                </p>
                <p className="ant-upload-hint">
                  สามารถอัปโหลดครั้งละ 1 ไฟล์ รองรับนามสกุล .xlsx เท่านั้น
                  ขนาดไม่เกิน 10 MB
                </p>
              </div>
            </section>
          </Row>
          <Row
            gutter={[24]}
            style={{
              margin: "15px 10px 15px 5px",
            }}
          >
            <label>อัปโหลดไฟล์</label>
          </Row>

          {dataShow?.data?.code === "ERR-0040" ? (
            <>
              <div
                style={{
                  marginBottom: 25,
                  border: "2px solid #FEC84B",
                  backgroundColor: "#FFFCF5",
                }}
              >
                <Row
                  gutter={[24]}
                  style={{
                    margin: "15px 10px 15px 5px",
                  }}
                >
                  <Col span={19} style={{ color: "#B54708" }}>
                    ไฟล์นำเข้ามีข้อผิดพลาด
                  </Col>
                  <Col span={5} style={{ textAlign: "right" }}>
                    <Link
                      target="_blank"
                      to={
                        routes.import_error +
                        `/${dataShow?.data?.objectValue?.sessionId}`
                      }
                      className="items-end"
                      style={{ color: "#B54708" }}
                    >
                      ดูรายละเอียด&nbsp;
                      <ArrowRightOutlined
                        style={{ color: "#B54708", paddingTop: 10 }}
                      />
                    </Link>
                  </Col>
                </Row>
              </div>

              <Row>
                <p style={{ margin: "0px" }}>
                  {dataShow?.data?.objectValue?.fileName}
                </p>
              </Row>
              <Row>
                <p style={{ margin: "0px" }}>
                  {dataShow?.data?.objectValue?.fileMsg}
                </p>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <p style={{ margin: "0px" }}>
                  {dataShow?.data?.objectValue?.fileName}
                </p>
              </Row>
              <Row>
                <p style={{ margin: "0px" }}>
                  {dataShow?.data?.objectValue?.fileMsg}
                </p>
              </Row>
            </>
          )}
        </Form>
      </div>
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        open={failModal}
        setOpen={setFailModal}
        title={failTitle}
        subTitle={failSubtitle}
      />
    </WithSidebar>
  );
};

export default ImportFile;
